import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { intlShape, injectIntl } from 'react-intl';

import PropTypes from 'prop-types';

import { bindActionCreators } from 'redux';
import * as actions from '../../../../actions/providers.actions';
import * as actionsReferences from '../../../../actions/references.actions';
import * as home from '../../../../actions/process.home.actions';
import { get } from '../../../../api/_basic';

import TextField from '@material-ui/core/TextField';
import Hidden from '@material-ui/core/Hidden';

import Loading from '../../../dialogs/loading';
import Error from '../../../dialogs/Error';
import Snackbar from '../../../labels/Snackbar';
import Menu from '../Menu';
import Contacts from './ContactsTable';
import Provides from './ProvidesTable';

import { BlueTickIcon } from '../../../../images/icons/WrapSvg';

// eslint-disable-next-line
import style from './_style.css';

function isOk(field) {
    return field === undefined || field.length < 2;
}

function helperText(field, intl) {
    return field === undefined || field.length === 0
        ? intl.formatMessage({ id: 'required' })
        : field.length < 2
            ? intl.formatMessage({ id: 'min_length_2' })
            : '';
}

function toolbar(handleSummit) {
    return (
        <BlueTickIcon
            key="submmit-post-provider"
            className="hand"
            color="primary"
            onClick={handleSummit}
        />
    );
}

class Provider extends React.Component {
    state = {
        id: undefined,
        nombre: '',
        contactos: [],
        provee: [],
        types: [],
    };

    constructor(props) {
        super(props);
        props.loadReferences();
        if (props.id) {
            props.loadProvider(props.id);
        }

        get(process.env.REACT_APP_API_MASTER + '/tipoContacto').then((data) => {
            this.setState({
                types: data
                    ? Object.keys(data).map((i) => {
                        return data[i];
                    })
                    : [],
            });
        });
    }

    componentWillUnmount() {
        this.props.setTools([]);
    }

    static getDerivedStateFromProps(props, state) {
        if (props.provider !== state.provider && props.id !== undefined) {
            state.provider = props.provider;
            state.nombre = props.provider && props.provider.nombre ? props.provider.nombre : '';
            state.contactos = props.provider ? props.provider.contactos : [];
            state.provee = props.provider ? props.provider.provee : [];
            return state;
        }
        return null;
    }

    handleBack = () => {
        /*
            let path = this.props.history.location.pathname.split('/');
            path.splice(path.length - 1, 1);
            path = path.join('/');
            this.props.history.push(path);
            */
           if(this.props.lastLocation && this.props.lastLocation.pathname === "/user/login") {
            this.props.history.push("/");
        } else {
            this.props.history.goBack();
        }  
    };

    updateHandle(state) {
        if (this.isCorrect(state)) {
            const tools = [toolbar(this.handleSummit)];
            this.props.setTools(tools);
        } else {
            this.props.setTools([]);
        }
    }

    handleScroll = (e) => {
        this.props.setProminentToolBar(e.currentTarget.scrollTop === 0);
    };

    handleChange = (event) => {
        const state = this.state;
        state[event.target.name] = event.target.value;
        this.updateHandle(state);
        console.log(state);
        this.setState(state);
    };

    isCorrect = (state) => {
        if (!state) return false;
        const { nombre, contactos, provee } = state;
        return (
            nombre &&
            nombre.length > 1 &&
            contactos &&
            contactos.length > 0 &&
            provee &&
            provee.length > 0
        );
    };

    handleSummit = () => {
        const { nombre, contactos, provee } = this.state;
        const provider = {
            nombre: nombre,
            contactos: contactos.map((r) => {
                if (typeof r.id !== 'number') {
                    r.id = undefined;
                }
                return r;
            }),
            provee: provee.map((r) => {
                if (typeof r.id !== 'number') {
                    r.id = undefined;
                }
                return r;
            }),
        };
        console.log(provider);
        if (!this.props.id) {
            this.props
                .addProvider(provider)
                .then((r) => {
                    this.props.history.push('/manage/providers');
                })
                .catch((error) => {
                    console.error(error);
                    this.setState({ error: error.message, errorType: error.type });
                });
        } else {
            provider.id = this.props.id;
            this.props
                .editProvider(provider)
                .then((r) => {
                    this.props.history.push('/manage/providers');
                })
                .catch((error) => {
                    console.error(error);
                    this.setState({ error: error.message, errorType: error.type });
                });
        }
    };

    handleClose = () => {
        this.setState({ error: undefined });
    };

    render() {
        const { nombre, contactos, provee, error, errorType, types } = this.state;
        const { intl, id, info, providers_is_loading, providers_has_errored } = this.props;
        if (
            info &&
            info.security &&
            info.security.totalPermits &&
            !(info.security.totalPermits.some((f) => f === '64') &&
              info.security.licencias.some((f) => f.id === 150 && f.activo))
        ) {
            return <Error open id={'unauthorized_access'} handleClose={this.handleBack} />;
        } else if (id && providers_has_errored.hasErrored) {
            return (
                <Error open type={providers_has_errored.hasErrored}  message={providers_has_errored.error} handleClose={this.handleBack} />
            );
        } else {
            return (
                <div className={'flex_full_row bg_ice_blue'}>
                    {providers_is_loading && <Loading open opacity />}
                    {error && (
                        <Snackbar
                            open={true}
                            variant={ errorType ? errorType : "error" }
                            text={error}
                            onClose={this.handleClose}
                        />
                    )}
                    <Hidden xsDown>
                        <div
                            className={
                                'flex_20 overflow_y_scroll padding_top_12 shadow_right_on_tablet bg_white showbar'
                            }
                            onScroll={this.handleScroll}
                        >
                            <Menu code={2} />
                        </div>
                    </Hidden>
                    <div className={'flex_full bg_white'}>
                        <div className={'flex_full_column padding_bottom_9 height100'}>
                            <div
                                className="flex_full overflow_y_scroll "
                                onScroll={this.handleScroll}
                            >
                                <div className="flex_full_column padding_borders">
                                    <TextField
                                        fullWidth
                                        id={'nombre'}
                                        name={'nombre'}
                                        error={isOk(nombre)}
                                        helperText={helperText(nombre, intl)}
                                        label={intl.formatMessage({ id: 'form_field_name_nombre' })}
                                        className={'flex_full_row'}
                                        value={nombre}
                                        onChange={this.handleChange}
                                        margin="normal"
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                </div>
                                <div className="flex_full_column padding_borders">
                                    <Contacts
                                        {...this.props}
                                        types={types}
                                        data={contactos}
                                        onChange={this.handleChange}
                                    />
                                </div>
                                <div className="flex_full_column padding_borders">
                                    <Provides
                                        {...this.props}
                                        data={provee}
                                        onChange={this.handleChange}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
    }
}

Provider.propTypes = {
    intl: intlShape.isRequired,
    provider: PropTypes.object.isRequired,
    providers_has_errored: PropTypes.object.isRequired,
    providers_is_loading: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => {
    return {
        providers_has_errored: state.providers_has_errored,
        providers_is_loading: state.providers_is_loading,
        provider: state.provider,
        references: state.references,
        info: state.info,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(Object.assign({}, actions, actionsReferences, home), dispatch);
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(injectIntl(Provider)));



// WEBPACK FOOTER //
// ./src/components/complex/manage/provider/Index.js